// @section: brand-components
import { cn } from "@/lib/utils";

/* @section: logo */
export function Logo({ className, dark = false }: { className?: string; dark?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2 select-none", className)}>
      <span
        className="grid place-items-center h-7 w-7 rounded-[3px] bg-accent text-accent-foreground font-bold text-lg leading-none"
        aria-hidden
      >
        L
      </span>
      <span
        className={cn(
          "text-xl font-bold tracking-tight",
          dark ? "text-white" : "text-primary"
        )}
      >
        linect
      </span>
    </span>
  );
}

/* @section: section-heading */
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
  className,
}: {
  eyebrow?: string;
  title: React.ReactNode;
  description?: string;
  align?: "left" | "center";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "max-w-3xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      {eyebrow && (
        <div
          className={cn(
            "inline-flex items-center gap-2 mb-4",
            align === "center" && "justify-center"
          )}
        >
          <span className="h-[2px] w-6 bg-accent" />
          <span className="text-xs font-semibold uppercase tracking-[0.18em] text-accent">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-primary leading-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
